<template>
  <div v-if="isTag" class="specialist-item py-1 px-4 mb-2 mr-2 d-inline-block">
    <div class="row">
      <div class="col-10">
        <span class="font-weight-bold d-block text-nowrap">
          {{ specialistText }}
        </span>
        <small v-if="specialist.specialistNeedSupervisor">
          <span class="text-muted">Sup.</span>
          {{ specialist.specialistSupervisorFullName }}
        </small>
      </div>
      <div v-if="!isReadOnly" class="col-2 align-self-center text-center">
        <i
          class="far fa-times-circle text-red cursor-pointer"
          @click="$emit('delete', specialist)"
        />
      </div>
    </div>
  </div>
  <custom-callout
    v-else
    :border-color="'gray'"
    class-main="mt-1 rounded mb-2"
    :has-toggle="false"
    :opened="false"
  >
    <div class="p-2 mr-md-0 align-items-center">
      <div class="row">
        <div class="col-lg-3 col-sm-12">
          <div class="color-gray-6 font-14">
            Nombre del Especialista:
          </div>
          <div class="color-black font-16">
            {{ specialist.specialistName | empty }}
          </div>
        </div>

        <div
          v-if="specialist.specialistNeedSupervisor"
          class="col-lg-3 col-sm-12"
        >
          <div class="color-gray-6 font-14">Supervisor:</div>
          <div class="color-black font-16">
            {{ specialist.specialistSupervisorFullName | empty }}
          </div>
        </div>

        <div
          class="col-sm-12"
          :class="specialist.specialistNeedSupervisor ? 'col-lg-2' : 'col-lg-3'"
        >
          <div class="color-gray-6 font-14">
            Requiere Transportación:
          </div>
          <div class="color-black font-16">
            {{ specialist.specialistNeedTransportation ? 'Si' : 'No' }}
          </div>
        </div>

        <div
          v-if="specialist.specialistNeedTransportation"
          class="col-sm-12"
          :class="specialist.specialistNeedSupervisor ? 'col-lg-2' : 'col-lg-3'"
        >
          <div class="color-gray-6 font-14">
            Costo de Transportación:
          </div>
          <div class="font-16 color-green font-weight-bold">
            {{ transportationCost | price }}
          </div>
        </div>

        <div v-if="!isReadOnly" class="col d-flex justify-content-end">
          <div class="align-self-center">
            <action-button
              i="pl-1 fas fa-times-circle"
              variant="outline-danger"
              @click="$emit('delete', specialist)"
            />
          </div>
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';

export default {
  name: 'SpecialistItem',
  components: {
    ActionButton,
    CustomCallout,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isTag: {
      type: Boolean,
      default: () => true,
    },
    transportationCost: {
      type: Number,
      default: () => 0,
    },
    specialist: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    specialistText() {
      return `${this.specialist.specialistName} - ${this.specialist.ssn?.slice(
        0,
        4
      )}`;
    },
  },
};
</script>
<style scoped lang="scss">
.specialist-item {
  border-radius: 50px;
  border: 1px solid gainsboro;
  width: fit-content;
  font-size: 90%;
}
.align-self-center {
  align-self: center !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
